import { usd } from "../../dashboard/api";
import { Panel } from "./ui";

const Cell = ({ label, value, accent = false, testId }) => (
    <div className="px-4 py-4 sm:px-5" data-testid={testId}>
        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-nx-mute">{label}</p>
        <p className={`mt-1.5 text-lg font-extrabold tabular ${accent ? "text-nx-lime" : "text-nx-text"}`}>{value}</p>
    </div>
);

export const FinancialOverview = ({ financial }) => (
    <Panel title="Financial Overview" className="mt-6" testId="financial-overview" padded={false}>
        <div className="grid grid-cols-2 divide-x divide-y divide-white/5 lg:grid-cols-5 lg:divide-y-0">
            <Cell label="Est. Monthly Salary" value={usd(financial.estMonthlySalary)} testId="fin-salary" />
            <Cell label="USDT Balance" value={Number(financial.usdtBalance).toFixed(2)} testId="fin-usdt" />
            <Cell label="Total Profit" value={usd(financial.totalProfit)} accent testId="fin-profit" />
            <Cell label="Salary Fund" value={usd(financial.salaryFund)} testId="fin-salary-fund" />
            <Cell label="Token Fund" value={usd(financial.tokenFund)} testId="fin-token-fund" />
        </div>
    </Panel>
);
